import { NgModule } from '@angular/core';

import { OrdensServicoComponent } from './ordens-servico.component';
import {SharedModule} from "../../shared/shared.module";
import {OrdensServicoRoutingModule} from "./ordens-servico-routing.module";
import {OrdemServicoListComponent} from "./ordem-servico-list/ordem-servico-list.component";
import {OrdemServicosFormComponent} from "./ordem-servico-form/ordem-servico-form.component";
import {OrdemServicoApiService} from "./shared/ordem-servico-api.service";
import {OrdemServicoNavigationService} from "./shared/ordem-servico-navigation.service";
import {OrdemServicoService} from "./shared/ordem-servico.service";
import {OrdemServicoDetailComponent} from "./ordem-servico-detail/ordem-servico-detail.component";
import {OrdemServicoItemFormComponent} from "./ordem-servico-item/ordem-servico-item-form/ordem-servico-item-form.component";
import {OrdemServicoItemTableComponent} from "./ordem-servico-item/ordem-servico-item-table/ordem-servico-item-table.component";
import {OrdemServicoCalendarComponent} from "./ordem-servico-calendar/ordem-servico-calendar.component";
import {OdometrosHorimetrosModule} from "../odometros-horimetros/odometros-horimetros.module";

@NgModule({
    imports: [
        SharedModule,
        OdometrosHorimetrosModule,
        OrdensServicoRoutingModule
    ],
    providers: [
        OrdemServicoApiService,
        OrdemServicoNavigationService,
        OrdemServicoService
    ],
    declarations: [
        OrdensServicoComponent,
        OrdemServicoListComponent,
        OrdemServicosFormComponent,
        OrdemServicoDetailComponent,
        OrdemServicoItemFormComponent,
        OrdemServicoItemTableComponent,
        OrdemServicoCalendarComponent
    ],
    exports: [
        OrdemServicoItemTableComponent
    ]
})
export class OrdensServicoModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordens-servico.module.ts
 **/